import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getPostPaginationList, getProjectCompleteList } from "../../../../../redux/project/action";
import ListLoader from "../../../../CustomComponents/AllLoader/ListLoader";
import { getRemaindays } from "../../../../Common/AllDateTimeReleventFormate";
import { useRouteBaseStateContext } from "../../../../../Context/RouteBaseStateContext";
import GetStatus from "../../../MyOrders/MyOrders/PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetStatus";
import GetRemainDays from "../../../MyOrders/MyOrders/PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetRemainDays";
import PostNotFound from "../../../../CustomComponents/AllLoader/PostNotFound";
import { PAGE_SIZE } from "../../../../../redux/constants";
import OrderPostPagination from "../../../FindWork/SearchAll/AllPosts/CustomPagination/OrderPostPagination";
import PostStatusLabel from "../../../../Common/PostStatusLabel";

export default function CancelledProjects({ data }) {
  const { setMyorderActiveprojectroute } = useRouteBaseStateContext();

  const path = "Assets/scss/myorders.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const laung = localStorage.getItem("laung");
  const [lan, setlan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(getProjectCompleteList(1));
  // }, []);

  const [listdata, setListdata] = useState("")
  const [pageNumber, setPageNumber] = useState(0);


  useEffect(() => {
    const data = {
      type: 1,
      index: pageNumber,
      size: PAGE_SIZE,
      status: 4
    }
    if (data) {
      dispatch(getPostPaginationList(data)).then((res) => {
        setListdata(res)
      })
    }
  }, [pageNumber]);


  return (
    <div className="order-tabs">
      <div className="tab-content">
        <div className="posted-project">
          {Array.isArray(listdata?.response) && (
            <>
              <h4>Project</h4>
              <OrderPostPagination
                totalitemcounts={listdata?.count}
                size={PAGE_SIZE}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
              />
              {listdata?.response?.length == 0 && <PostNotFound title={"No Post Found"} />}
              <div className="recent-post">
                {listdata?.response.slice(0, 10).map((item, index) => (
                  <div className="post-back">
                    <div className="col-md-5 ">
                      <h3>{item?.title}</h3>
                      <PostStatusLabel status={item?.status} />
                    </div>
                    <div className="activity col-md-4">
                      <h6>Active milestone: {item?.active_milestone_count}</h6>
                      <h5>
                        {!item?.active_milestone?.title
                          ? "No Active Milestone"
                          : item?.active_milestone?.title}
                      </h5>
                      <GetStatus status={item?.active_milestone?.status} />
                    </div>
                    <button
                      className="btn"
                      onClick={() => {
                        navigate(
                          `/${lan}/dashboard/managework/projects/active/${item.id}`,
                        );
                        setMyorderActiveprojectroute("");
                      }}
                    >
                      View details
                      <img
                        src={`${CloudStorage.cloudurl}Assets/Images/homepage/right-arrow-orange.svg`}
                        alt=""
                      />
                    </button>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
